import React from "react";
import Order from "../components/order/Order";
import TitleUpdater from "../components/common/layout/TitleUpdater";

export default function OrderPage() {

  return (
    <div>
      <TitleUpdater />
      <Order />
    </div>
  );
}
